import React, { useEffect, useState, useMemo } from "react";
import { useAPI } from "../Context/MyContext";
import { TemplateModal } from "./TemplateModal";
import Toolbar from "../Component/Template/Toolbar";

import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import { useStateContex } from "../Context/UseStateContet";
import { set } from "react-hook-form";

const GetTemplate = () => {
  const { getUserWabaIds, getTemplateByWabaId } = useAPI();

  const [wabaIds, setWabaIds] = useState([]);
  //selectedWabaId is
  const { selectedWabaId, setSelectedWabaId, selectedPhoneNumberId, setSelectedPhoneNumberId } = useStateContex()


  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [isTempateFound, setIsTemplateFound] = useState(true);

  // console.log("wabaIds", wabaIds)
  // Controlled pagination state
  const [paginationModel, setPaginationModel] = useState({
    pageSize: 10,
    page: 0,
  });

  // Filters
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedLanguage, setSelectedLanguage] = useState("");

  // Step 1: Fetch WABA IDs


  useEffect(() => {
    const fetchWabaIds = async () => {
      setLoading(true);
      setError("");
      try {
        const res = await getUserWabaIds();


        // ✅ Extract array safely
        const details = res?.data || [];

        console.log("getUserWabaIds", res);

        // ✅ Filter unique by business_id (or id — whichever you prefer)
        const uniqueWabaIds = details.filter(
          (item, index, self) =>
            index === self.findIndex((t) => t.waba_id === item.waba_id)
        );

        if (uniqueWabaIds.length > 0) {

          console.log("Unique WABA IDs:", uniqueWabaIds);
          setWabaIds(uniqueWabaIds);
          setSelectedWabaId(uniqueWabaIds[0].waba_id);
          setSelectedPhoneNumberId(uniqueWabaIds[0].phone_number_id);
        } else {
          setError("No WhatsApp Business Account IDs found.");
        }
      } catch (err) {
        console.error(err);
        setError("Failed to load WhatsApp Business Account IDs.");
      } finally {
        setLoading(false);
      }
    };

    fetchWabaIds();
  }, []);





  // Step 2: Fetch Templates
  useEffect(() => {
    const fetchTemplates = async () => {
      if (!selectedWabaId) return;
      setLoading(true);
      setError("");
      try {
        const res = await getTemplateByWabaId(selectedWabaId);
        setTemplates(res?.data || []);
        setIsTemplateFound(true)
      } catch (err) {
        // console.error("Error fetching templates:", err);
        if (err?.response?.data?.message) {
          setError(err.response.data.message);
        } else {
          setError("Failed to fetch templates for the selected account.");
        }
        setTemplates([]);
        setSelectedTemplate(null);
        setIsTemplateFound(false);
      } finally {
        setLoading(false);
      }
    };

    fetchTemplates();
  }, [selectedWabaId]);

  // Get unique languages & categories from templates
  const categories = useMemo(
    () => [...new Set(templates.map((t) => t.category))],
    [templates]
  );
  const languages = useMemo(
    () => [...new Set(templates.map((t) => t.language))],
    [templates]
  );

  // Filtered templates
  const filteredTemplates = templates.filter((t) => {
    const matchesSearch = searchQuery
      ? t.name.toLowerCase().includes(searchQuery.toLowerCase())
      : true;
    const matchesCategory = selectedCategory
      ? t.category === selectedCategory
      : true;
    const matchesLanguage = selectedLanguage
      ? t.language === selectedLanguage
      : true;

    return matchesSearch && matchesCategory && matchesLanguage;
  });

  // DataGrid columns
  const columns = [
    { field: "name", headerName: "Template Name", flex: 1 },
    { field: "category", headerName: "Category", flex: 1 },
    { field: "language", headerName: "Language", flex: 1 },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        let color = "text-gray-600";
        if (params.value?.toLowerCase() === "approved")
          color = "text-green-600 font-semibold";
        if (params.value?.toLowerCase() === "rejected")
          color = "text-red-600 font-semibold";
        if (params.value?.toLowerCase() === "pending")
          color = "text-yellow-600 font-semibold";
        return <span className={color}>{params.value}</span>;
      },
    },
  ];

  const openModal = (template) => {
    setSelectedTemplate(template);
    setIsModalOpen(true);
  };

  return (
    <div className="p-6 max-w-7xl mx-auto min-h-screen">
      <h1 className="text-3xl font-bold mb-6">WhatsApp Template</h1>

      {/* WABA Dropdown */}
      <div className="mb-6 bg-white shadow-sm rounded-xl p-4">
        <label className="block mb-2 text-gray-800 font-medium">
          Select WhatsApp Business Account:
        </label>
        <select
          value={selectedWabaId}
          // onChange={(e) => setSelectedWabaId(e.target.value)}
          onChange={(e) => {
            setSelectedWabaId(e.target.value);
            const selectedWaba = wabaIds.find(waba => waba.waba_id === e.target.value);
            setSelectedPhoneNumberId(selectedWaba?.phone_number_id || "");
          }}

          className="border rounded-lg p-2 w-80 focus:outline-none focus:ring-2 focus:ring-blue-500"
          disabled={loading || wabaIds.length === 0}
        >
          <option disabled value="">
            Select WhatsApp Business Account
          </option>
          {wabaIds.map((waba, idx) => (

            <option key={idx} value={waba.waba_id}>
              {/* {waba.verified_name} ({waba.waba_id}) */}
              {waba.verified_name} ({waba.display_phone_number})
            </option>
          ))}
        </select>
      </div>

      {/* <div className="mb-6 bg-white shadow-sm rounded-xl p-4">
        <label className="block mb-2 text-gray-800 font-medium">
          Select WhatsApp Business Account:
        </label>
        <select
          value={selectedWabaId}
          onChange={(e) => setSelectedWabaId(e.target.value)}
          className="border rounded-lg p-2 w-80 focus:outline-none focus:ring-2 focus:ring-blue-500"
          disabled={loading || wabaIds.length === 0}
        >
          <option disabled value="">
            Select WhatsApp Business Account
          </option>
          {wabaIds.map((waba, idx) => (
            <option key={idx} value={waba.business_id}>
              {waba.verified_name} — {waba.display_phone_number}
            </option>
          ))}
        </select>
      </div> */}


      <Toolbar

        categories={categories}
        languages={languages}
        onCategoryChange={setSelectedCategory}
        onLanguageChange={setSelectedLanguage}
        onSearchChange={setSearchQuery}
        isTempateFound={isTempateFound}
        wabaId={selectedWabaId}
        phoneNumberId={selectedPhoneNumberId}
        onCreateTemplate={() => {
          // Navigate to create template page
          // window.location.href = '/NewTemplate';
          // OR if using react-router:
          // navigate('/NewTemplate');
          // console.log('Navigate to create template');
        }}
      />

      {/* Error */}
      {error && (
        <div className="text-red-600 bg-red-50 p-3 rounded mb-4">{error}</div>
      )}

      {/* Loader */}
      {loading && (
        <div className="flex justify-center items-center h-48">
          <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-blue-500 border-solid"></div>
        </div>
      )}

      {/* DataGrid Table */}
      {!loading && filteredTemplates.length > 0 && (
        <Box sx={{ height: 500, width: "100%", bgcolor: "white" }}>
          <DataGrid
            rows={filteredTemplates.map((t, i) => ({ id: i + 1, ...t }))}
            columns={columns}
            pageSizeOptions={[5, 10, 20]}
            paginationModel={paginationModel}
            onPaginationModelChange={setPaginationModel}
            pagination
            disableRowSelectionOnClick
            onRowClick={(params) => openModal(params.row)}
          />
        </Box>
      )}

      {/* No Templates */}
      {!loading && filteredTemplates.length === 0 && selectedWabaId && (
        <p className="mt-4 text-gray-600 text-center">
          No templates found for this WhatsApp Business Account.
        </p>
      )}

      {/* Template Modal */}
      <TemplateModal
        template={selectedTemplate}
        isOpen={isModalOpen} 
        onClose={() => setIsModalOpen(false)}
        phone_number_id={selectedWabaId}
      // wabaIds={wabaIds}
      />
    </div>
  );
};

export default GetTemplate;

